import React from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { useDispatch } from 'react-redux'

import styles, { colors } from '../../../../styles/global'
import { setAssistantEnabled } from '../../../../../redux/actions'
import {
    TASK_TYPE_PROMPT,
    TASK_TYPE_EXTERNAL_LINK,
    TASK_TYPE_WEBHOOK,
    TASK_TYPE_IFRAME,
} from '../../../../UIComponents/FloatModals/PreConfigTaskModal/TaskModal'
import Icon from '../../../../Icon'
import { generateTaskFromPreConfig } from '../../../../../utils/assistantHelper'

export default function PreConfigTaskOption({
    task,
    closeModal,
    selectTask,
    onSelectBotOption,
    enableAssistantForObject,
    inMyDay,
    projectId,
    assistantId,
}) {
    const dispatch = useDispatch()
    const {
        name,
        prompt,
        variables,
        type,
        link,
        aiModel,
        aiReasoningEffort,
        aiSystemMessage,
        taskMetadata,
        sendWhatsApp,
    } = task

    console.log('PreConfigTaskOption selected:', {
        taskName: name,
        type,
        aiSettings: {
            model: aiModel,
            reasoningEffort: aiReasoningEffort,
            systemMessage: aiSystemMessage,
        },
    })

    // Get icon based on task type
    const getIconForTaskType = () => {
        switch (type) {
            case TASK_TYPE_PROMPT:
                return 'message-square'
            case TASK_TYPE_EXTERNAL_LINK:
                return 'external-link'
            case TASK_TYPE_WEBHOOK:
                return 'link-2'
            case TASK_TYPE_IFRAME:
                return 'monitor'
            default:
                return 'cpu' // fallback
        }
    }

    const onPress = () => {
        console.log('PreConfigTaskOption onPress - type check:', {
            type,
            TASK_TYPE_IFRAME,
            isIframeType: type === TASK_TYPE_IFRAME,
            link,
        })
        if (type === TASK_TYPE_PROMPT) {
            if (variables.length > 0) {
                selectTask(task)
            } else {
                closeModal()
                enableAssistantForObject?.()
                const aiSettings = {
                    model: aiModel,
                    reasoningEffort: aiReasoningEffort,
                    systemMessage: aiSystemMessage,
                }
                onSelectBotOption(prompt, name, aiSettings, {
                    taskMetadata: {
                        ...(taskMetadata || {}),
                        sendWhatsApp: !!sendWhatsApp,
                    },
                })
                if (!enableAssistantForObject && !inMyDay) dispatch(setAssistantEnabled(true))
            }
        } else if (type === TASK_TYPE_WEBHOOK) {
            closeModal()
            // For webhook tasks, create a task and execute the webhook
            const aiSettings = {
                model: aiModel,
                reasoningEffort: aiReasoningEffort,
                systemMessage: aiSystemMessage,
            }
            // Build taskMetadata including sendWhatsApp
            const mergedTaskMetadata = {
                ...(taskMetadata || {}),
                sendWhatsApp: !!sendWhatsApp,
                executionMode: task.executionMode,
            }
            generateTaskFromPreConfig(projectId, name, assistantId, prompt, aiSettings, mergedTaskMetadata)
        } else if (type === TASK_TYPE_IFRAME) {
            closeModal()
            dispatch({
                type: 'Set iframe modal data',
                visible: true,
                url: link,
                name: name,
            })
        } else {
            closeModal()
            window.open(link, '_blank')
        }
    }

    return (
        <TouchableOpacity style={localStyles.container} onPress={onPress}>
            <View style={localStyles.content}>
                <Icon name={getIconForTaskType()} size={20} color="#FFFFFF" style={localStyles.icon} />
                <Text style={localStyles.text}>{name}</Text>
            </View>
        </TouchableOpacity>
    )
}

const localStyles = StyleSheet.create({
    container: {
        height: 48,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    content: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    icon: {
        marginRight: 8,
    },
    text: {
        ...styles.subtitle1,
        color: '#FFFFFF',
        flex: 1,
    },
})
